import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { SEOHead } from '../components/SEOHead';
export function Contact() {
  return <>
      <SEOHead title="Book a Call | Free Strategy Call | Viridia Analytics Phoenix" description="Book a free 15-minute strategy call. No pitch, just a real look at where you're losing leads and how the system catches them." canonical="/contact" data-id="element-1756" data-mp="1qoblg7jwq9ct" />

      <PageHeader label="Contact" title="Book a strategy call. No pitch." intro="Fifteen minutes on where your leads are getting dropped. If we can't help, we'll tell you." data-id="element-1757" data-mp="t24foubvaayv" />

      <section className="border-b border-[#1a1a1a]" data-id="element-1758" data-mp="12zik1vkin9at">
        <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20" data-id="element-1759" data-mp="12xpc8cy62j18">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_2fr]" data-id="element-1760" data-mp="f8wlcuwej1dh">
            <ul className="space-y-6 text-sm" data-id="element-1761" data-mp="abwguof7a6oh">
              <li className="flex items-start gap-3" data-id="element-1762" data-mp="a90i4xvj3dyz">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-1763" data-mp="15eds5pxphinv" />
                <span data-id="element-1764" data-mp="19fz0cxzap8rq">
                  <span className="block font-mono text-xs uppercase tracking-[0.15em] text-neutral-600" data-id="element-1765" data-mp="19fh441cmuujt">
                    Phone
                  </span>
                  <a href="tel:6233000708" className="mt-1 block text-neutral-200 hover:text-emerald-500" data-id="element-1766" data-mp="1j7d5bla0n0s9">
                    (623) 300-0708
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1767" data-mp="qjzhccoapfka">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-1768" data-mp="vg7op3w944gw" />
                <span data-id="element-1769" data-mp="10hdil51ndxs0">
                  <span className="block font-mono text-xs uppercase tracking-[0.15em] text-neutral-600" data-id="element-1770" data-mp="10hnc32lwin2g">
                    Email
                  </span>
                  <a href="mailto:info@viridiaanalytics.com" className="mt-1 block break-all text-neutral-200 hover:text-emerald-500" data-id="element-1771" data-mp="2buptfzvtrgno">
                    info@viridiaanalytics.com
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1772" data-mp="1w5t3zk5fkuqz">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-1773" data-mp="1w3gln5vrgide" />
                <span data-id="element-1774" data-mp="1r4lwznb43zld">
                  <span className="block font-mono text-xs uppercase tracking-[0.15em] text-neutral-600" data-id="element-1775" data-mp="13gm52k22e357">
                    Where
                  </span>
                  <span className="mt-1 block text-neutral-200" data-id="element-1776" data-mp="yjlym81ayydk">
                    Phoenix, AZ &middot; Serving local businesses
                  </span>
                </span>
              </li>
            </ul>

            <div className="overflow-hidden rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d]" data-id="element-1777" data-mp="18dvw2453qmv5">
              <iframe src="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" title="Book a 15-minute call with Viridia Analytics" className="w-full" style={{
              minHeight: '900px',
              border: 'none'
            }} scrolling="no" data-id="element-1778" data-mp="ko9tr7tfnrix" />
            </div>
          </div>
        </div>
      </section>
    </>;
}